var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "button",
      {
        staticClass: "product-filter__button",
        class: { "product-filter__button--active": _vm.open },
        attrs: { disabled: _vm.fixedBrand && !_vm.priceRange.length },
        on: {
          click: function($event) {
            return _vm.toggle()
          }
        }
      },
      [_vm._v("\n    " + _vm._s(_vm.$modeoL10n.filter_verb) + "\n  ")]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "product-filter__selected-filters" },
      [
        !_vm.open && _vm.selectedFilters.length <= 2
          ? _vm._l(_vm.selectedFilters, function(filter, index) {
              return _c("button", {
                key: index,
                staticClass: "filter-text-tag filter-text-tag--small",
                class: [
                  _vm.selectedFilters.length > 2
                    ? "filter-text-tag--never"
                    : "filter-text-tag--in-large"
                ],
                domProps: { innerHTML: _vm._s(_vm.$sanitize(filter.label)) },
                on: {
                  click: function($event) {
                    return _vm.removeFilter(index)
                  }
                }
              })
            })
          : _vm._e(),
        _vm._v(" "),
        !_vm.open && _vm.selectedFilters.length > 0
          ? _c(
              "button",
              {
                staticClass: "filter-number-tag",
                class: [
                  _vm.selectedFilters.length > 2
                    ? "filter-number-tag--always"
                    : "filter-number-tag--in-small"
                ],
                on: {
                  click: function($event) {
                    return _vm.toggle()
                  }
                }
              },
              [
                _vm._v(
                  "\n      " + _vm._s(_vm.selectedFilters.length) + "\n    "
                )
              ]
            )
          : _vm._e()
      ],
      2
    ),
    _vm._v(" "),
    (!_vm.fixedBrand || _vm.priceRange.length) && _vm.open
      ? _c("div", { staticClass: "product-filter__dropdown" }, [
          _vm.selectedFilters.length
            ? _c(
                "div",
                {
                  staticClass:
                    "product-filter__dropdown-section product-filter__dropdown-section--tags"
                },
                [
                  _vm._l(_vm.selectedFilters, function(filter, index) {
                    return _c("button", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showFilter(filter),
                          expression: "showFilter(filter)"
                        }
                      ],
                      key: index,
                      staticClass: "filter-text-tag",
                      domProps: {
                        innerHTML: _vm._s(_vm.$sanitize(filter.label))
                      },
                      on: {
                        click: function($event) {
                          return _vm.removeFilter(index)
                        }
                      }
                    })
                  }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "link",
                      on: {
                        click: function($event) {
                          return _vm.removeFilters()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$modeoL10n.remove_filters) +
                          "\n      "
                      )
                    ]
                  )
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.fixedBrand
            ? _c(
                "div",
                {
                  staticClass:
                    "product-filter__dropdown-section product-filter__dropdown-section--with-more"
                },
                [
                  _c(
                    "p",
                    {
                      staticClass: "product-filter__dropdown-section__heading"
                    },
                    [
                      _vm._v(
                        "\n        " + _vm._s(_vm.$modeoL10n.brand) + "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm.visibleBrands.length > 0
                    ? _c(
                        "ul",
                        { staticClass: "product-filter__options" },
                        _vm._l(_vm.visibleBrands, function(brand) {
                          return _c(
                            "li",
                            {
                              key: brand.id,
                              staticClass:
                                "product-filter__option product-filter__option--checkbox"
                            },
                            [
                              _c(
                                "label",
                                { staticClass: "product-filter__label" },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.selectedBrands[brand.id],
                                        expression: "selectedBrands[brand.id]"
                                      }
                                    ],
                                    staticClass: "checkbox-input",
                                    attrs: {
                                      type: "checkbox",
                                      "true-value": brand
                                    },
                                    domProps: {
                                      checked: Array.isArray(
                                        _vm.selectedBrands[brand.id]
                                      )
                                        ? _vm._i(
                                            _vm.selectedBrands[brand.id],
                                            null
                                          ) > -1
                                        : _vm._q(
                                            _vm.selectedBrands[brand.id],
                                            brand
                                          )
                                    },
                                    on: {
                                      change: [
                                        function($event) {
                                          var $$a =
                                              _vm.selectedBrands[brand.id],
                                            $$el = $event.target,
                                            $$c = $$el.checked ? brand : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                _vm.$set(
                                                  _vm.selectedBrands,
                                                  brand.id,
                                                  $$a.concat([$$v])
                                                )
                                            } else {
                                              $$i > -1 &&
                                                _vm.$set(
                                                  _vm.selectedBrands,
                                                  brand.id,
                                                  $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1))
                                                )
                                            }
                                          } else {
                                            _vm.$set(
                                              _vm.selectedBrands,
                                              brand.id,
                                              $$c
                                            )
                                          }
                                        },
                                        function($event) {
                                          return _vm.updateSelectedFilters({
                                            emitToParent: true
                                          })
                                        }
                                      ]
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("span", {
                                    class: [
                                      "checkbox-label",
                                      "product-filter__option__value",
                                      { "modeo-plus": brand.title == "Modeo+" }
                                    ],
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.$sanitize(brand.title)
                                      )
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "product-filter__option__count"
                                    },
                                    [_vm._v(_vm._s(brand.count))]
                                  )
                                ]
                              )
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.visibleBrands.length == 0
                    ? _c("div", [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.$modeoL10n.no_brands) +
                            "\n      "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.brandsWhichHaveProducts().length > 5
                    ? _c(
                        "button",
                        {
                          staticClass:
                            "product-filter__show-more show-more-button",
                          class: {
                            "show-more-button--close": _vm.showAllBrands
                          },
                          on: {
                            click: function($event) {
                              return _vm.toggleBrands()
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _vm.showAllBrands
                                  ? _vm.$modeoL10n.hide
                                  : _vm.$modeoL10n.show_more +
                                      " (" +
                                      (_vm.brandsWhichHaveProducts().length -
                                        5) +
                                      ")"
                              ) +
                              "\n      "
                          )
                        ]
                      )
                    : _vm._e()
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.priceRange.length
            ? _c("div", { staticClass: "product-filter__dropdown-section" }, [
                _c(
                  "p",
                  { staticClass: "product-filter__dropdown-section__heading" },
                  [
                    _vm._v(
                      "\n        " + _vm._s(_vm.$modeoL10n.price) + "\n      "
                    )
                  ]
                ),
                _vm._v(
                  "\n      " +
                    _vm._s(_vm._f("formatIntPrice")(_vm.price[0])) +
                    " – " +
                    _vm._s(_vm._f("formatIntPrice")(_vm.price[1])) +
                    "\n      "
                ),
                _c(
                  "div",
                  { staticClass: "price" },
                  [
                    _c("vue-slider", {
                      ref: "slider",
                      attrs: {
                        min: _vm.priceRange[0],
                        max: _vm.priceRange[1],
                        interval: _vm.priceRangeInterval
                      },
                      on: {
                        "drag-end": function($event) {
                          return _vm.priceChanged()
                        }
                      },
                      model: {
                        value: _vm.price,
                        callback: function($$v) {
                          _vm.price = $$v
                        },
                        expression: "price"
                      }
                    })
                  ],
                  1
                )
              ])
            : _vm._e()
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8da95596", { render: render, staticRenderFns: staticRenderFns })
  }
}